module.exports = __webpack_public_path__ + "static/inspection_service.7ccc00a6.png";